/** 客户端解析 JWT payload（不做签名校验，仅用于与缓存用户信息对齐） */
export function decodeJwtPayload(
  token: string | null | undefined,
): { sub?: number; role?: string; username?: string } | null {
  const raw = String(token || '').trim();
  const parts = raw.split('.');
  if (parts.length < 2) return null;
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const json = atob(padded);
    const payload = JSON.parse(json) as Record<string, unknown>;
    return {
      sub: typeof payload.sub === 'number' ? payload.sub : Number(payload.sub) || undefined,
      role: typeof payload.role === 'string' ? payload.role : undefined,
      username: typeof payload.username === 'string' ? payload.username : undefined,
    };
  } catch {
    return null;
  }
}

export function decodeJwtRole(token: string | null | undefined): string | undefined {
  return decodeJwtPayload(token)?.role;
}
